export default __webpack_public_path__ + "assets/icons/express-direction.0056fa09.svg";